module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("FOR MY FRIENDS")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("‘Come, come. Did we not all start out with more important matters on our minds?’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("A man I think I overheard in a bar.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00e8ef20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_Dedication01.vue
// module id = 69
// module chunks = 0